module.exports = __webpack_public_path__ + "img/mantenimiento.2ef8af35.jpg";